module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9r8r3r6r-3a886b8e75e2f22236511dbf36bd9944.svg";